"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MyDecisionParams () {
        return MyDecisionParams;
    },
    get MyDecisionsResponse () {
        return MyDecisionsResponse;
    },
    get SubmitDecisionsRequest () {
        return SubmitDecisionsRequest;
    },
    get SubmitDecisionsResponse () {
        return SubmitDecisionsResponse;
    },
    get UpdateMyDecisionsNotesRequest () {
        return UpdateMyDecisionsNotesRequest;
    },
    get UpdateMyDecisionsNotesResponse () {
        return UpdateMyDecisionsNotesResponse;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const MyDecisionParams = _zod.z.object({
    cycleId: _utilsisomorphic.transformObjectId
});
const MyDecisionsResponse = _zod.z.object({
    compensationCycleDetails: _models.CompensationCycleModel.nullable(),
    directReportsToMakeDecisionsFor: _zod.z.object({
        results: _zod.z.array(_zod.z.object({
            _id: _utilsisomorphic.transformObjectId,
            company_id: _utilsisomorphic.transformObjectId,
            compensation_cycle: _utilsisomorphic.transformObjectId,
            employee_id: _utilsisomorphic.transformObjectId,
            created_at: _zod.z.date(),
            manager_id: _utilsisomorphic.transformObjectId,
            override_manager_id: _utilsisomorphic.transformObjectId.nullable(),
            current_salary: _zod.z.number(),
            current_salary_currency: _zod.z.string(),
            proposed_increase_amount: _zod.z.number().min(0).nullable(),
            proposed_increase_percent: _zod.z.number().min(0).nullable(),
            proposed_salary: _zod.z.number().min(0).nullable(),
            status: _zod.z.string(),
            current_approver_id: _utilsisomorphic.transformObjectId.nullable(),
            approvals: _zod.z.array(_models.ApprovalEntryModel),
            name: _zod.z.string(),
            jobTitle: _zod.z.string(),
            manager_name: _zod.z.string(),
            current_manager_viewing: _zod.z.string(),
            updated_at: _zod.z.date().optional()
        })),
        total: _zod.z.number()
    })
});
const UpdateMyDecisionsNotesRequest = _zod.z.object({
    cycleId: _zod.z.string(),
    managerId: _zod.z.string(),
    notesByDecisionRowId: _zod.z.record(_zod.z.string(), _zod.z.string())
});
const UpdateMyDecisionsNotesResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const SubmitDecisionsRequest = _zod.z.array(_zod.z.object({
    _id: _zod.z.string(),
    current_salary: _zod.z.number(),
    employee_id: _zod.z.string(),
    notes: _zod.z.string(),
    proposed_increase_amount: _zod.z.number(),
    proposed_increase_percent: _zod.z.number(),
    proposed_salary: _zod.z.number(),
    compensation_cycle_id: _zod.z.string()
}));
const SubmitDecisionsResponse = _zod.z.object({
    success: _zod.z.boolean()
});
